import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { addDoc, arrayRemove, collection, deleteDoc, doc, getDocs, updateDoc } from 'firebase/firestore'
import { auth, db } from '../../firebase/firebase'

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import { 
  Alert,
  Box,
  Button,
  Card, 
  Grid, 
  IconButton, 
  List, 
  ListItem, 
  ListItemText, 
  Paper, 
  Snackbar, 
  Stack, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Tooltip, 
  Typography} from '@mui/material'
import ListaDiagramas from '../../Components/ListaDiagramas';
import ModalSistema from '../../Components/Alertas/ModalSistema';

const MisDiagramas = () => {

  const [diagramas, setDiagramas] = useState([])
  
  const user = auth.currentUser;
  const navigate = useNavigate();

  const [nodosDiagrama, setNodosDiagrama] = useState([]);
  const [lineasDiagrama, setLineasDiagrama] = useState([]);
  const [colecciones, setColecciones] = useState([]);

  const [abrirModal, setAbrirModal] = useState(false);
  const handleClose = () => setAbrirModal(false);
  const [idEliminar, setIdEliminar] = useState('');

  //Para abrir el snackbar
  const [open, setOpen] = useState(false);


  const handleClick = () => {
      setOpen(true);
      setTimeout(() => {
          setOpen(false);
      }, 3000);
  };

  const obtenerDiagramas = async() =>{
    try {

      const querySnapshot = await getDocs(collection(db, user.uid));
      const arrayData = querySnapshot.docs.map( doc => 
        (
          {idDocumento: doc.id, ...doc.data()}
        ))      
      setDiagramas(arrayData);
      
    } catch (error) {
      
    }
  }

  const obtenerColecciones = async() =>{

    let arrayAux = [];

    try {

        const querySnapshot = await getDocs(collection(db, 'colecciones'));
        querySnapshot.docs.forEach( (doc) => {
        if(doc.data().usuario === user.uid){
            arrayAux.push({id: doc.id, ...doc.data()});
        }
        }); 
        setColecciones(arrayAux);
        
    } catch (error) {
        
    }
}


  useEffect(() => {
    obtenerDiagramas();
    obtenerColecciones();
  }, [])
  
  const editarDiagrama = (id) =>{
    
    let titulo = '';
    let fecha = '';
    let coleccion = []
    diagramas.forEach((diagrama)=>{
      if(diagrama.idDocumento === id){

        diagrama.nodos.forEach((node)=>{
          let newNode = JSON.parse(node);
          /* console.log(newNode); */
          nodosDiagrama.push(newNode)
        })

        diagrama.lineas.forEach((line)=>{
          let newLine = JSON.parse(line);
          /* console.log(newLine) */
          lineasDiagrama.push(newLine);
        })

        titulo = diagrama.titulo;
        fecha = diagrama.fecha;
        coleccion = diagrama.coleccion;
      }
    })

    navigate('/lienzo', 
      {state:
        {
          idDocumento:id, 
          titulo: titulo,
          fecha: fecha,
          nodosDiagrama: nodosDiagrama, 
          lineasDiagrama: lineasDiagrama,
          coleccion: coleccion,
        }
      })
  }

  const handleOpen = (id) =>{
    setIdEliminar(id);
    setAbrirModal(true);
  }

  const eliminarDiagrama = async() =>{

    obtenerDiagramas();
    obtenerColecciones();

    let arrayAux = [];

    colecciones.map(async (cole)=>{
      arrayAux=cole.diagramas;
      
      cole.diagramas.map(async (diagrama, index)=>{
        if(diagrama.idDocumento === idEliminar){
          /* arrayAux.splice(index, 1); */
          await updateDoc(doc(db, 'colecciones', cole.id),{
            diagramas: arrayRemove(diagrama)
          })
        }
      })
    })

    await deleteDoc(doc(db, user.uid, idEliminar));
    setIdEliminar('');
    setAbrirModal(false);
    obtenerDiagramas();
    handleClick();
  }

  return (
    <>
      <Box sx={{ marginLeft: "20%", borderBottom: "1px solid", width: "60%", marginTop: "3%" }}>
          <Grid container>
              <Grid item xs={10} md={10}>
                <Typography 
                    component="div" 
                    gutterBottom 
                    style={{ color: "#000", fontSize: "35px", fontWeight: 'bold'}}
                >
                    DIAGRAMAS
                </Typography>
              </Grid>
              <Grid item xs={2} md={2} alignContent='center' textAlign={'center'}>
                <Tooltip title='Nuevo diagrama' >
                  <Button
                    variant="outlined"
                    endIcon={<AddCircleIcon/>}
                    onClick={()=>{navigate('/lienzo')}}
                    style={{
                      marginTop: 10
                    }}
                    >
                    Nuevo
                  </Button>
                </Tooltip>
              </Grid>
          </Grid>
      </Box>
      <br/>
      <Box sx={{ marginLeft: "20%", width: '60%' , marginTop: '30px' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <ListaDiagramas
            diagramas={diagramas}
            editarDiagrama={editarDiagrama}
            eliminarDiagrama={handleOpen}
            colection={false}
            subcol={false}
          />
        </Box>
        {
          diagramas.length > 0 ? 
            (null)
            :
            (
            <Alert 
              variant="outlined" 
              severity="info"
              sx={{mt: 2}}
            >
              No tienes diagramas creados!
            </Alert>
            )
        }
      </Box>
      
      {abrirModal && (
        <ModalSistema
            abrirModal={abrirModal}
            handleClose={handleClose}
            funcion={eliminarDiagrama}
            titulo={'Elimar diagrama'}
            mensaje={'¿Desea eliminar el diagrama de forma permanente?'}
        />
      )}
      <Stack spacing={2} sx={{ width: '100%' }}>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
              <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                Eliminado con éxito!
              </Alert>
          </Snackbar>
      </Stack>
      
    </>        
  )
}

export default MisDiagramas